import React, { useEffect } from "react";
// 引入 AOS 動畫庫與其樣式檔，用於頁面元素的淡入淡出效果
import Aos from "aos";
import "aos/dist/aos.css";
// 引入本元件的 CSS 樣式檔
import "./signature.css";
// 引入 React Router 的 Link，用於頁面導覽
import { Link } from "react-router-dom";

// 引入圖示
import { HiOutlineLocationMarker } from "react-icons/hi";

// 引入圖片資源
import img4 from "../../Assets/signImg/img4.jpeg";

/*
  Data 陣列：
  - 儲存行程資訊，包括圖片來源、標題、地點、執行機構、費用以及描述等。
  - 如需擴充更多行程，請在此陣列中新增對應物件。
*/
const Data = [
  {
    id: 4,
    imgSrc: img4,
    destTitle: "放 飛 一 夏 - 歡樂美國夏令營",
    location: "🇺🇸 · 美國 · 佛羅里達",
    company: "美國 · 跨文化體驗",
    fees: "3490 美元",
    description:
      "與美國在地學生共度私校夏令營，沉浸市民生活，參訪政府與文化機構；沐浴陽光，漫步沙灘，共賞壯麗夕陽；暢遊迪士尼、環球影城、樂高樂園與甘迺迪太空中心，樂享無限歡愉。",
  },
];

/*
  Signature4 元件：
  - 初始化 AOS 動畫庫，設定動畫持續時間為 2000 毫秒。
  - 透過 Data 陣列動態渲染行程資訊。
  - 提供返回首頁的按鈕，以及詳細的行程、費用和參團資訊等表格資料。
  - 全部文字內容已依臺灣用語習慣轉為繁體中文。
*/
export default function Signature4() {
  // 使用 useEffect 在元件掛載時初始化 AOS 動畫效果
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="signMain signContainer signSection">
      {/* 頁面標題區塊 */}
      <div className="signSecTitle">
        <h3 data-aos="fade-right" className="signTitle">
          放 飛 一 夏 - 歡樂美國夏令營
        </h3>
        <button className="signHomeBtn">
          <Link to="/" className="signHomeBtnLink">
            返回首頁
          </Link>
        </button>
      </div>

      {/* 主要內容區：利用 Grid 佈局渲染每個行程資訊 */}
      <div className="signSecContent signGrid">
        {Data.map(
          ({ id, imgSrc, destTitle, location, company, fees, description }) => {
            return (
              <div
                key={id}
                data-aos="fade-up"
                className="signSingleDestination"
              >
                {/* 左側文字資訊區 */}
                <div className="signCardInfo">
                  {/* 行程標題 */}
                  <h4 className="signDestTitle">{destTitle}</h4>
                  {/* 地點資訊，搭配圖示 */}
                  <span className="signContinent signFlex">
                    <HiOutlineLocationMarker className="icon" />
                    <span className="signName">{location}</span>
                  </span>

                  {/* 行程詳情區 */}
                  <div className="signFees signFlex">
                    {/* 執行機構與行程特色說明 */}
                    <div className="signGrade">
                      <span>
                        執行機構：{company}
                        <br />
                        <br />
                        <small>⭐️ 行 程 精 華 ⭐️</small>
                        <br />
                        <br />
                      </span>
                    </div>
                    <div>
                      <h6>{description}</h6>
                      <br />
                      {/* 行程亮點與特色表格 */}
                      <table width="70%">
                        <thead>
                          <tr>
                            <th width="20%"></th>
                            <th width="10%"></th>
                            <th width="70%"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>活動亮點</td>
                            <td></td>
                            <td>
                              私立學校夏令營項目：文藝、體育、科學、戶外活動;
                              <br />
                              社會活動：拜訪國會議員、消防局、警署，垃圾處理、野生動物救助;
                              <br />
                              歡樂週末：迪士尼樂園、環球影城、樂高樂園、甘迺迪航天中心;
                            </td>
                          </tr>
                          <tr>
                            <td>沉浸式體驗</td>
                            <td></td>
                            <td>
                              與當地私立學校學生一同活動；參訪社會機構、參與市民活動、融入當地生活;
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* 參團資訊表格區 */}
                  <div className="signFees signFlex">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 參 團 資 訊 ⭐️</small>
                      </span>
                      <br />
                      <br />
                    </div>
                    <table width="70%">
                      <thead>
                        <tr>
                          <th width="15%"></th>
                          <th width="10%"></th>
                          <th width="75%"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>參團年齡</td>
                          <td></td>
                          <td>14-18 歲學生</td>
                        </tr>
                        <tr>
                          <td>適合人群</td>
                          <td></td>
                          <td>
                            喜愛迪士尼等主題公園；結交朋友；美國私立學校；美國社會活動
                          </td>
                        </tr>
                        <tr>
                          <td>時間安排</td>
                          <td></td>
                          <td>7 月「為期 16 天」</td>
                        </tr>
                        <tr>
                          <td>地 點</td>
                          <td></td>
                          <td>美國 · 佛羅里達</td>
                        </tr>
                        <tr>
                          <td>費用包含</td>
                          <td></td>
                          <td>
                            學生在私立學校活動的費用、抵達後至離開美國期間的正餐費用、住宿費用、交通費用、主題公園門票費用。
                          </td>
                        </tr>
                        <tr>
                          <td>費用不包含</td>
                          <td></td>
                          <td>
                            國際旅行手續費、往返國際機票、國際旅行醫療保險、意外保險、個人購物、個人消費。
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* 參考行程區塊 */}
                  <div className="signFees">
                    <div className="signGrade">
                      <span>
                        <small>⭐️ 參 考 行 程 ⭐️</small>
                      </span>
                      <br />
                      <br />
                    </div>
                    <h6>行程範例</h6>
                    <p>
                      實際活動內容可能會有前後調整，或被相近內容替代；夏令營正式開始前四週確定行程細節。
                    </p>
                    <br />
                    <table width="100%">
                      <thead>
                        <tr>
                          <th width="10%">日 期</th>
                          <th width="40%">私 校 活 動</th>
                          <th width="50%">校 外 活 動</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>星期六</td>
                          <td>出發</td>
                          <td>抵達飯店休息</td>
                        </tr>
                        <tr>
                          <td>星期日</td>
                          <td>歡樂一天：樂高樂園</td>
                          <td>樂高樂園遊玩</td>
                        </tr>
                        <tr>
                          <td>星期一</td>
                          <td>私立學校夏令營活動第一日</td>
                          <td>
                            歡迎晚宴，超市採購日常用品，休息調整時差
                          </td>
                        </tr>
                        <tr>
                          <td>星期二</td>
                          <td>私立學校夏令營活動第二日</td>
                          <td>校外課堂：野生動物保育站</td>
                        </tr>
                        <tr>
                          <td>星期三</td>
                          <td>私立學校夏令營活動第三日</td>
                          <td>社會活動：參訪社區警署</td>
                        </tr>
                        <tr>
                          <td>星期四</td>
                          <td>私立學校夏令營活動第四日</td>
                          <td>社會活動：參訪救護中心</td>
                        </tr>
                        <tr>
                          <td>星期五</td>
                          <td>私立學校夏令營活動第五日</td>
                          <td>社會活動：拜訪消防局</td>
                        </tr>
                        <tr>
                          <td>星期六</td>
                          <td>
                            歡樂一天：迪士尼 / 環球影城 瘋狂一下
                          </td>
                          <td>
                            迪士尼樂園 / 環球影城 二選一遊玩
                          </td>
                        </tr>
                        <tr>
                          <td>星期日</td>
                          <td>科學一天：甘迺迪航天中心</td>
                          <td>前沿科技，真實航天飛行器</td>
                        </tr>
                        <tr>
                          <td>星期一</td>
                          <td>私立學校夏令營活動第六日</td>
                          <td>
                            享受白色沙灘休閒時光 / 滿天霞光日落
                          </td>
                        </tr>
                        <tr>
                          <td>星期二</td>
                          <td>私立學校夏令營活動第七日</td>
                          <td>社會活動：拜訪國會議員</td>
                        </tr>
                        <tr>
                          <td>星期三</td>
                          <td>私立學校夏令營活動第八日</td>
                          <td>校外課堂：海灣自然保護區生物課</td>
                        </tr>
                        <tr>
                          <td>星期四</td>
                          <td>私立學校夏令營活動第九日</td>
                          <td>校外課堂：早期美洲移民生活村落</td>
                        </tr>
                        <tr>
                          <td>星期五</td>
                          <td>私立學校夏令營活動第十日</td>
                          <td>
                            歡送晚宴；Outlets 購物中心採購
                          </td>
                        </tr>
                        <tr>
                          <td>星期六</td>
                          <td>
                            歡樂一天：迪士尼樂園 / 環球影城 瘋狂一下
                          </td>
                          <td>
                            迪士尼樂園（四個園區）/ 環球影城 任選一遊玩
                          </td>
                        </tr>
                        <tr>
                          <td>星期日</td>
                          <td>返程日</td>
                          <td>順利回家</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {/* 預售價格與預報名按鈕區 */}
                  <div className="signPrice">
                    <h5>預售價格 ：{fees}</h5>
                  </div>
                  <button className="signBtn signFees">
                    <Link to={"/formReg"} target="_blank">
                      <h4>⭐️ ⭐️ ⭐️ 預 約 報 名 - 搶 先 卡 位 ⭐️ ⭐️ ⭐️</h4>
                    </Link>
                  </button>
                </div>

                {/* 右側圖片區塊 */}
                <div className="signImageDiv">
                  <img src={imgSrc} alt={destTitle} />
                </div>
              </div>
            );
          }
        )}
      </div>
    </section>
  );
}